import {
  Page,
  useAssetConfig,
  useAssetParams,
  useAssetQuery,
  useHasAssetPermissions,
} from '@mss/mss-component-library';
import React, { useState } from 'react';
import Breadcrumbs from '../../Breadcrumbs';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { sanitizedUrl } from '../../../asset/util/sanitize';
import Collections from './Collections';
import { useTranslation } from 'react-i18next';
import MonitorSettings from './MonitorSettings';
import RemoteProfiles from '../../../asset/components/remote-profiles';
import Settings from './Settings';
import ISAEConfiguration from './ISAEConfiguration';
import OPCConfiguration from './OPCConfiguration';
import OperationalStatusButton from './OperationalStatusButton';
import DeleteAssetButton from './DeleteAssetButton';
import RemoteConnectModal from '../../../asset/components/RemoteConnectModal';
import AssetRemoteActionsDetail from './AssetRemoteActionsDetail';
import Sidebar from './Sidebar';
import { useConfigurationQuery } from '../../../index';
import FieldPRMOPCConfiguration from './FieldOPCConfiguration';

const routesFactory = (path: string) => ({
  root: `${path}/`,
  settings: `${path}/asset-settings`,
  monitors: `${path}/monitor-settings`,
  collection: `${path}/collection-settings`,
  remote: `${path}/remote-profiles`,
  isae: `${path}/isae-configuration`,
  opcConfiguration: `${path}/opc-configuration`,
  fieldOpcConfiguration: `${path}/field-opc-configuration`,
});

function Edit() {
  const { path, url } = useRouteMatch();
  const { assetSubType } = useAssetParams();
  const { matchingConfig } = useAssetConfig(assetSubType);
  const permissions = useHasAssetPermissions();
  const { t } = useTranslation(['common', 'asset']);
  const [connectModal, openConnectModal] = useState<string | null>(null);
  const routes = routesFactory(path);
  const { data, isLoading } = useAssetQuery(!matchingConfig);
  const { data: config } = useConfigurationQuery();
  return (
    <Page
      breadCrumbs={
        <Breadcrumbs
          label={isLoading ? `${t('Loading')}...` : data?.name}
        />
      }
      actions={
        <>
          {permissions.view &&
            !matchingConfig.disableOperationalStatus &&
            !!data && (
              <OperationalStatusButton disabled={!permissions.change} />
            )}
          {permissions.delete && <DeleteAssetButton />}
          {!matchingConfig.disableRemoteAccess && !config?.unidirectional && (
            <AssetRemoteActionsDetail openConnectModal={openConnectModal} />
          )}
        </>
      }
      sidebar={<Sidebar />}
      main={
        <>
          {!matchingConfig ? (
            <h1 className="text-center my-10">
              404 - Asset configuration not found
            </h1>
          ) : (
            <Switch>
              <Route
                path={routes.root}
                exact
                render={() => (
                  <Redirect to={`${sanitizedUrl(url)}/asset-settings`} />
                )}
              />
              <Route path={routes.settings} exact component={Settings} />
              <Route path={routes.collection} exact component={Collections} />
              <Route path={routes.monitors} component={MonitorSettings} />
              <Route
                path={`${path}/remote-profiles`}
                component={RemoteProfiles}
              />
              <Route path={routes.isae} component={ISAEConfiguration} />
              <Route
                path={routes.opcConfiguration}
                component={OPCConfiguration}
              />
                <Route
                path={routes.fieldOpcConfiguration}
                component={FieldPRMOPCConfiguration}
              />
            </Switch>
          )}
          <RemoteConnectModal
            closeModal={() => openConnectModal(null)}
            asset={data as any}
            visible={!!connectModal}
          />
        </>
      }
    />
  );
}

export default Edit;
